import { url } from 'mk/urls/autogenhelper';
import * as wallUrls from 'mk2/apps/wall/urls';
import { Route } from 'mk2/containers/Application/Application';
import RedirectPage from 'mk2/pages/RedirectPage';

export const routes: Route[] = [{
    app: 'wall',
    exact: true,
    path: wallUrls.wall,
    page: new RedirectPage<{folder: string}>({
        to: (props) => url(wallUrls.wallMentions, {username: props.requestUser.username}),
        permanent: true,
        authOnly: true,
    }),
}, {
    app: 'wall',
    exact: true,
    path: wallUrls.wallMentions,
    getPage: () => {
        return import('mk2/apps/wall/containers/MentionsList/MentionsListPage' /* webpackChunkName: "wall.MentionsList" */);
    },
    modules: [ 'mk2/apps/wall/containers/MentionsList/MentionsListPage' ],
}];
